export default __webpack_public_path__ + "static/contract-builder-icon-3441027d26b6358b13d67b27b379c5c3.png";